const LeybaProLogo = ({ size = "md", showDownload = false, className = "", isGlowing = false }) => {
  const sizes = {
    xs: { width: 50, noteSize: 35, proSize: "text-[8px]" },
    sm: { width: 70, noteSize: 50, proSize: "text-[10px]" },
    md: { width: 90, noteSize: 65, proSize: "text-xs" },
    lg: { width: 120, noteSize: 90, proSize: "text-sm" },
    xl: { width: 150, noteSize: 110, proSize: "text-base" }
  };

  const { width, noteSize, proSize } = sizes[size] || sizes.md;

  return (
    <div className={`inline-flex flex-col items-center justify-center ${className} ${isGlowing ? 'animate-pulse' : ''}`}>
      {/* Musical Note L Logo */}
      <div 
        className={`flex items-center justify-center ${isGlowing ? 'animate-bounce' : ''}`} 
        style={{ width, height: noteSize }}
      >
        <svg 
          viewBox="0 0 80 100" 
          width={noteSize}
          height={noteSize}
          className={isGlowing 
            ? 'drop-shadow-[0_0_20px_rgba(255,215,0,1)] animate-[glow_1s_ease-in-out_infinite_alternate]' 
            : 'drop-shadow-[0_0_10px_rgba(255,215,0,0.5)]'
          }
          style={isGlowing ? {
            filter: 'drop-shadow(0 0 15px #FFD700) drop-shadow(0 0 30px #FF6B6B) drop-shadow(0 0 45px #FFD700)'
          } : {}}
        >
          <defs>
            <linearGradient id={isGlowing ? "goldGradientNoteGlow" : "goldGradientNote"} x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor={isGlowing ? "#FFFFFF" : "#FFF8DC"} />
              <stop offset="30%" stopColor="#FFD700" />
              <stop offset="70%" stopColor={isGlowing ? "#FF6B6B" : "#DAA520"} />
              <stop offset="100%" stopColor={isGlowing ? "#FFD700" : "#B8860B"} />
            </linearGradient>
            <filter id={isGlowing ? "glowNoteActive" : "glowNote"}>
              <feGaussianBlur stdDeviation={isGlowing ? "3" : "1.5"} result="coloredBlur"/>
              <feMerge>
                <feMergeNode in="coloredBlur"/>
                <feMergeNode in="SourceGraphic"/>
              </feMerge>
            </filter>
          </defs>
          
          {/* Stem (vertical part) */}
          <rect 
            x="32" 
            y="5" 
            width="10" 
            height="65" 
            rx="2"
            fill={`url(#${isGlowing ? "goldGradientNoteGlow" : "goldGradientNote"})`}
            filter={`url(#${isGlowing ? "glowNoteActive" : "glowNote"})`}
          />
          
          {/* Flag (curved part of corchea) */}
          <path 
            d="M42 5 
               C55 8, 65 18, 65 28
               C65 38, 55 42, 45 40
               L42 39
               L42 22
               C50 24, 55 22, 55 17
               C55 12, 50 8, 42 7
               Z"
            fill={`url(#${isGlowing ? "goldGradientNoteGlow" : "goldGradientNote"})`}
            filter={`url(#${isGlowing ? "glowNoteActive" : "glowNote"})`}
          />
          
          {/* Note head (oval at bottom) */}
          <ellipse 
            cx="25" 
            cy="80" 
            rx="16" 
            ry="11" 
            fill={`url(#${isGlowing ? "goldGradientNoteGlow" : "goldGradientNote"})`}
            filter={`url(#${isGlowing ? "glowNoteActive" : "glowNote"})`}
            transform="rotate(-20, 25, 80)"
          />
          
          {/* Connection from stem to note head */}
          <path 
            d="M32 70 Q25 72, 20 78 Q18 82, 22 85 L30 82 Q34 78, 32 70"
            fill={`url(#${isGlowing ? "goldGradientNoteGlow" : "goldGradientNote"})`}
            filter={`url(#${isGlowing ? "glowNoteActive" : "glowNote"})`}
          />
        </svg>
      </div>
      
      {/* PRO Text - Centered Below */}
      <div className="flex items-center justify-center mt-1">
        <span 
          className={`${proSize} font-black tracking-[0.25em] uppercase ${isGlowing ? 'animate-pulse' : ''}`}
          style={{ 
            fontFamily: 'Arial Black, Helvetica, sans-serif',
            background: isGlowing 
              ? 'linear-gradient(90deg, #FF6B6B, #FFD700, #FFFFFF, #FFD700, #FF6B6B)' 
              : 'linear-gradient(90deg, #FFD700, #FFF8DC, #DAA520)',
            backgroundSize: isGlowing ? '200% auto' : 'auto',
            animation: isGlowing ? 'shimmer 1.5s linear infinite' : 'none',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}
        >
          PRO
        </span>
      </div>
      
      {/* Launch Alert Badge */}
      {isGlowing && (
        <div className="mt-2 px-3 py-1 bg-gradient-to-r from-[#FF6B6B] to-[#FFD700] rounded-full animate-pulse">
          <span className="text-[10px] font-bold text-black">🚀 LANZAMIENTO PRÓXIMO</span>
        </div>
      )}
    </div>
  );
};

export default LeybaProLogo;
